import React from "react";
import { connect } from "react-redux";
import { getRecord } from "../b5-unlocks/getUserBattleRecord.js";

class UserCrewRecord extends React.Component {
  renderRow(statLabel, statNumber) {
    const style = {
      display: "flex",
      justifyContent: "space-between"
    };
    return (
      <div style={style}>
        <div>
          {statLabel}
        </div>
        <div>
          {statNumber}
        </div>
      </div>
    );
  }

  render() {
    const containerStyle = {
      lineHeight: "2.3em"
    };

    const groupStyle = {
      paddingBottom: "1em",
      borderBottom: "0.2em solid #d1d1d2",
      marginBottom: "1.7em"
    };

    const record = getRecord();
    return (
      <div style={containerStyle}>
        <div style={groupStyle}>
          {this.renderRow("TOTAL BATTLES", record.totalBattles)}
          {this.renderRow("Wins", record.totalWins)}
          {this.renderRow("Losses", record.totalLosses)}
        </div>
        <div>
          {this.renderRow("Quick Battle Wins", record.quickBattleWins)}
          {this.renderRow("Versus Battle Wins", record.fullteamBattleWins)}
          {this.renderRow("Rally Battle Wins", record.openBattleWins)}
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {};
})(UserCrewRecord);



// WEBPACK FOOTER //
// ./src/battle/UserCrewRecord.js